import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

/**
 * Success message shown after form submission
 */
const ContactSuccess = ({ onReset }) => {
  return (
    <main data-testid="contact-page" className="pt-24 min-h-screen bg-[#0A0A0A]">
      <div className="container-custom py-24">
        <div className="max-w-xl mx-auto text-center">
          <div className="w-20 h-20 bg-[#56C6C6]/10 rounded-full flex items-center justify-center mx-auto mb-8">
            <CheckCircle className="w-10 h-10 text-[#56C6C6]" />
          </div>
          <h1 className="text-4xl font-bold text-white uppercase tracking-tight mb-4">
            Message Sent!
          </h1>
          <p className="text-zinc-400 text-lg mb-8">
            Thank you for reaching out. Our team will get back to you within 24-48 hours.
          </p>
          <Button
            onClick={onReset}
            data-testid="send-another-btn"
            className="bg-[#56C6C6] text-black hover:bg-[#45B5B5] font-bold uppercase tracking-wider px-6"
          >
            Send Another Message
          </Button>
        </div>
      </div>
    </main>
  );
};

export default ContactSuccess;
